<template>
  <CCard>
    <CCardHeader class="card-detail-header">
      <slot name="header">
        <span v-if="clientDetails" class="card-detail-header-title">
          <CIcon name="cil-notes" />
          Datos de facturación
        </span>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CForm class="form-mimoto mt-3" data-vv-scope="billing-info">

        <h5 class="subtitle">Actualiza tus datos de facturación
          <!-- <small v-if="clientDetails.type">
           ( {{ clientDetails.type | capitalize }} )
          </small> -->
        </h5>
        <p class="text-primary">Es necesario completar tus datos para descargar las facturas de tus productos contratados</p>

        <CRow form class="form-group" key="billing-data-custom">
          <CCol sm="6">
            <CInputCheckbox
              :checked.sync="clientDetails.company"
              @update:checked="() => changeCompanyBillingInfo(clientDetails.company)"
              custom
              label="Factura para empresa"
              class="my-2 mt-4"
            />
          </CCol>
          <CCol sm="6" class="form-inline">
            <CInputCheckbox
              :checked.sync="useClientData"
              custom
              label="Utilizar información de datos personales"
              class="my-2 mt-4"
            />
          </CCol>
        </CRow>

        <CRow>
          <CCol md="7">
            <label class="required" for="name"><strong>Nombre: </strong>
              <!-- <small v-if="clientDetails.billing_company">(Empresa)</small>
              <small v-else>(Particular)</small> -->
            </label>
            <CInput
              type="text"
              id="name" name="name"
              placeholder="Titular de la factura"
              autocomplete="name"
              v-model="clientDetails.billing_name"
              v-validate="'required'"
              data-vv-validate-on="change"
              v-bind:invalid-feedback="errors.first('billing-info.name')"
              :addInputClasses="{ 'is-invalid': errors.first('billing-info.name') }"
            >
            </CInput>
          </CCol>

        <CCol sm="2">
          <label class="required" for="identification_number">
            <strong>Tipo: </strong>
          </label>
          <CSelect
            id="type" name="identification_number"
            :plain="true"
            :value.sync="identification_type"
            :options="['NIF', 'CIF']"
            v-validate="'required'"
            data-vv-validate-on="change"
            v-bind:invalid-feedback="errors.first('billing-info.type')"
            :addInputClasses="{ 'is-invalid': errors.first('billing-info.type') }"
            >
          </CSelect>
        </CCol>

        <CCol md="3">
          <!--  :md="{'4': clientDetails.billing_company , '6': !clientDetails.billing_company}"  -->
          <label class="required" for="billing_identification">
            <!-- <strong>Identificación (NIF): </strong> -->
            <strong>Identificación ({{ identification_type }}): </strong>
            <!-- <strong>Identificación ({{ clientDetails.billing_identification_type }}): </strong> -->
          </label>
          <CInput
            type="text"
            id="identification_number" name="billing_identification"
            placeholder="Identificación del titular"
            autocomplete="name"
            v-model="clientDetails.billing_identification"
            v-validate="`required|identificacion:${identification_type}`"
            data-vv-validate-on="change"
            v-bind:invalid-feedback="errors.first('billing-info.billing_identification')"
            :addInputClasses="{ 'is-invalid': errors.first('billing-info.billing_identification') }"
          >
          </CInput>
        </CCol>

        <CCol md="7" v-if="isRequired || clientDetails.billing_company">
          <label for="billing_company" :class="{'required': isRequired}"><strong>Empresa: </strong>
          <small v-if="!isRequired">(Opcional)</small>
          </label>
          <CInput
            type="text"
            id="billing_company" name="billing_company"
            placeholder="Nombre empresa"
            autocomplete="name"
            v-model="clientDetails.billing_company"
            v-validate="{ required: isRequired }"
            data-vv-validate-on="change"
            v-bind:invalid-feedback="errors.first('billing-info.billing_company')"
            :addInputClasses="{ 'is-invalid': errors.first('billing-info.billing_company') }"
           />
        </CCol>

        </CRow>



        <CRow>

          <CCol md="7">
            <label class="required" for="address"><strong>Dirección: </strong>
              <!-- <small v-if="clientDetails.billing_company">(Empresa)</small>
              <small v-else>(Particular)</small> -->
            </label>
            <CInput
              type="text"
              id="address" name="address"
              placeholder="Dirección completa de la factura"
              autocomplete="name"
              v-model="clientDetails.billing_address"
              v-validate="'required'"
              data-vv-validate-on="change"
              v-bind:invalid-feedback="errors.first('billing-info.address')"
              :addInputClasses="{ 'is-invalid': errors.first('billing-info.address') }"
            >
            </CInput>
          </CCol>



          <CCol md="5" >
            <div role="group" class="form-group">
              <label for="province" class="required">
                <strong>Provincia: </strong>
                <!-- <small v-if="clientDetails.billing_company">(Empresa)</small>
                <small v-else>(Particular)</small> -->
              </label>
              <CInput
                type="text"
                id="province" name="province"
                placeholder="Escribe tu provincia"
                v-model="clientDetails.billing_province"
                v-validate="'required'"
                data-vv-validate-on="change"
                v-bind:invalid-feedback="errors.first('billing-info.province')"
                :addInputClasses="{ 'is-invalid': errors.first('billing-info.province')}"
              />
            </div>
          </CCol>


          <CCol md="7" >
            <div role="group" class="form-group">
              <label for="town" class="required">
                <strong>Municipio: </strong>
                <!-- <small v-if="clientDetails.billing_company">(Empresa)</small>
                <small v-else>(Particular)</small> -->
              </label>
              <CInput
                type="text"
                id="town" name="town"
                placeholder="Escribe tu municipio"
                v-model="clientDetails.billing_town"
                v-validate="'required'"
                data-vv-validate-on="change"
                v-bind:invalid-feedback="errors.first('billing-info.town')"
                :addInputClasses="{ 'is-invalid': errors.first('billing-info.town')}"
              />


            </div>
          </CCol>

          <CCol md="5" >
            <label for="postal_code" class="required">
              <strong>Código postal: </strong>
              <!-- <small v-if="clientDetails.billing_company">(Empresa)</small>
              <small v-else>(Particular)</small> -->
            </label>
              <!-- label="Código postal"
              addLabelClasses="required" -->
            <CInput
              id="postal_code"
              name="postal_code"
              type="text"
              placeholder="Introduce el código postal"
              v-model="clientDetails.postal_code"
              v-validate="'required'"
              data-vv-validate-on="change"
              v-bind:invalid-feedback="
                errors.first('billing-info.postal_code')
              "
              :addInputClasses="{
                'is-invalid': errors.first(
                  'billing-info.postal_code'
                ),
              }"
            >
            </CInput>
          </CCol>

        </CRow>


      </CForm>
    </CCardBody>

    <CCardFooter >
      <CButton type="submit" size="sm" color="success" style="float:right;" @click="updateBillingInfo">
        <CIcon name="cil-check-circle"/>
          Actualizar datos facturación
      </CButton>
    </CCardFooter>

    <toast ref="toast"></toast>
    <spinner-ttt :show="loading"></spinner-ttt>

  </CCard>

</template>

<script>
import { LABEL_ICON } from "@/config";
import validator from "@/validator";

export default {
  name: "BillingData2",
  props: {
    title: String,
    loading: { type: Boolean, default: true  },
    client: { type: Object, default: {}, required: true },
    downloadBilling: { type: Boolean, default: false },
  },
  data() {
    return {
      labelIcon: LABEL_ICON,
      // company: false,
      useClientData: false,
      identification_type: 'NIF',
      isRequired: false,

    };
  },
  created(){
  },
  computed: {
    clientDetails: function () {
      return { ...this.client };
    },
  },

  watch: {
    client: {
      immediate: true,
      handler(newClient) {
        if (newClient && newClient.billing_identification_type === 'empresa') {
          this.identification_type = 'CIF';
          this.isRequired = true;
        }
      }
    },
    useClientData(newVal, oldVal) {
      this.$emit('toggle-billing-data', newVal);
    },
  },
  methods: {
    changeCompanyBillingInfo(value) {
      this.isRequired = value;
      this.identification_type = value ? 'CIF' : 'NIF';
    },

    updateBillingInfo() {

      this.$validator.validateAll("billing-info").then((valid) => {

        if (valid) {

          // let fullAddress = `${this.clientDetails.address}, ${this.clientDetails.postal_code} ${this.clientDetails.billing_town}, ${this.clientDetails.billing_province}`

          const billingInfo = {
            // ...this.clientDetails, // limitar campos de edición
            id: this.clientDetails.id,
            billing_company: this.clientDetails.billing_company ? this.clientDetails.billing_company : null,
            billing_identification: this.clientDetails.billing_identification,
            billing_address: this.clientDetails.billing_address,
            billing_name: this.clientDetails.billing_name,
            billing_province: this.clientDetails.billing_province,
            billing_town: this.clientDetails.billing_town,
            postal_code: this.clientDetails.postal_code,

            // address: fullAddress, // Descartado
            billing_identification_type: this.clientDetails.company ? 'empresa' : 'particular',
          }

          this.$emit('updateClient', billingInfo)  // this.clientDetails
        } else {
          this.$refs.toast.showToast( "Los campos obligatorios son requeridos",null,"error","5000");
        }
      });
    },




  },
};
</script>
<style lang="scss" scoped>

.margin-form {
  margin-bottom: 0.8em;
}


</style>
